// src/services/rookieRankService.ts

import { apiClient } from "./apiClient";
import { RookieRankDto } from "../types/rookie.types";

/**
 * Get the authenticated user's own rookie rank ("Çaylak Onay Sırası").
 * Returns { rank: null, totalRookies: null } when the caller is not a rookie.
 * Only ever returns the caller's own rank — there is no lookup for other users.
 */
export const getMyRookieRank = async (): Promise<RookieRankDto> => {
  return apiClient.get<RookieRankDto>("/api/rookies/me/rank");
};